import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .findOptionsWidget{background-color:var(--vscode-editorWidget-background);border:2px solid var(--vscode-contrastBorder);box-shadow:0 0 8px 2px var(--vscode-widget-shadow);color:var(--vscode-editorWidget-foreground)}";
n(css,{});
export { css, css as default };
